import Vue from 'vue'

// utils
import { getFullNameFormat, getFullNameOnlyFormat } from '@/utils'

// constants
import { getTextTypeOfContract, getTextCondition } from '@/constants'

Vue.filter('formatFullNameEmployee', getFullNameFormat)
Vue.filter('textTypeOfContract', getTextTypeOfContract)
Vue.filter('employeeCondition', getTextCondition)
Vue.filter('employeeFullName', getFullNameOnlyFormat)
